import type { StaticTextResource } from '../keys'

export const es: StaticTextResource = {
  'schedule.dueToday': 'Hoy hasta las {{time}}',
  'schedule.dueTomorrow': 'Mañana hasta las {{time}}',
  'schedule.durationRange':
    '{{start}} - {{end}} (Día {{currentDay}} / {{days}} días)',
  'editReport.defaultPageName': 'Página {{n}}',
  'editReport.defaultSectionName': 'Sección',
  'editReport.defaultRepeatSectionName': 'Sección repetible',
}
